module.exports = "<footer>\n  <div>\n    <img  src=\"assets/img/onerecharge-logo-blue-png\" width=\"100\" alt=\"logo\"/>\n  </div>\n  <p>\n    &copy; {{year}}. {{vendor}}\n  </p>\n</footer>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/landing-page/common/landing-page-footer/landing-page-footer.component.html
// module id = ./src/app/home/pages/landing-page/common/landing-page-footer/landing-page-footer.component.html
// module chunks = main